import React from 'react';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

// Marks a ticket that was opened from OUTSIDE inesco — by a partner or by an end
// customer — the way AutoTicketService marks machine-generated ones with a
// literal "[Auto]" in the subject.
//
// Unlike "[Auto]" this tag is NOT stored in the subject. It is derived on the
// backend from the creator's account type (see IsExternalCreator in
// Controller.cs), which means it also covers tickets opened long before the tag
// existed, and an admin renaming a ticket cannot accidentally strip it.
//
// Admin-facing only: the client/partner endpoints deliberately omit the flag, so
// a partner never sees their own ticket labelled "external".
function ExternalTag() {
  return (
    <Box
      component="span"
      sx={{ color: 'warning.dark', fontWeight: 'bold', mr: 0.5 }}
    >
      <FormattedMessage id="ticketExternalTag" defaultMessage="[External]" />
    </Box>
  );
}

export default ExternalTag;
